module.exports = __webpack_public_path__ + "img/6.d6bb02d5.jpg";